import R from 'ramda';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import countries from 'country-calling-code';
// import { ReCaptcha } from 'react-recaptcha-v3';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  Checkbox,
} from 'react-bootstrap';
import NavButtons from '../components/NavButtons';
import Heading from '../components/Heading';
// import PhoneVerify from '../components/PhoneVerify';
import actions from '../redux/actions';
import actionTypes from '../redux/actionTypes';
import music from '../assets/music.svg';
import photo from '../assets/photo.svg';
import text from '../assets/text.svg';
import video from '../assets/video.svg';
// import { GOOGLE_RECPATCHA_KEY } from '../constants';

class Welcome extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      work: null,
      invalidToken: false,
      name: '',
      legalName: '',
      email: '',
      password: '',
      confirmPassword: '',
      address: '',
      city: '',
      state: '',
      postal: '',
      country: '',
      countryCode: '',
      tel: '',
      phoneVerified: false,
      verifiedNumber: null,
      verifiedCountryCode: null,
      attorney: false,
      terms: false,
      referrerId: null,
      // recaptchaToken: null,
    };
  }

  componentDidMount() {
    const { params, dispatch } = this.props;

    if (params && params.key) {
      dispatch(actions.getInviteByKey(params.key));
    }

    dispatch(actions.getOwnershipTypes());
    dispatch(actions.getWorkTypes());
    dispatch(actions.getSubWorkTypes());
  }

  componentWillReceiveProps(nextProps) {
    const { deal, invite, status, inviteStatus, error, dispatch } = nextProps;

    if (deal && !this.state.work) {
      this.setState({ work: deal.work_info });
    }

    if (this.props.inviteStatus !== inviteStatus) {
      if (inviteStatus === actionTypes.INVITE_GET_BY_KEY_SUCCESS && invite) {
        this.setState({
          email: invite.email,
          name: invite.name,
          attorney: invite.type === 'attorney',
        });
      } else if (inviteStatus === actionTypes.INVITE_GET_BY_KEY_ERROR) {
        this.setState({ invalidToken: true });
        dispatch(
          actions.alert(
            'error',
            'Invite token is not valid! Please confirm and retry again.'
          )
        );
      }
    }

    if (this.props.status === actionTypes.AUTH_SIGNUP_REQUEST) {
      if (status === actionTypes.AUTH_SIGNUP_SUCCESS) {
        // dispatch(actions.getProfile());
        // dispatch(actions.getRoles());
        // dispatch(actions.getContractBlocks());
        dispatch(
          actions.alert(
            'success',
            'We sent you a confirmation email. Please check your inbox and confirm your account!'
          )
        );
      } else if (status === actionTypes.AUTH_SIGNUP_ERROR) {
        if (error) {
          const errors = Object.values(error);
          errors.forEach((e) => dispatch(actions.alert('error', e[0])));
        } else {
          dispatch(
            actions.alert(
              'error',
              'Oops! Something went wrong. Please try to register again. If this error persists, please contact us.'
            )
          );
        }
      }
    }

    // if (this.props.profile.status === actionTypes.PROFILE_GET_REQUEST) {
    //   if (profile.status === actionTypes.PROFILE_GET_SUCCESS) {
    //     if (invite) {
    //       const dealUser = {
    //         deal: invite.deal,
    //         user: profile.id,
    //         type: invite.type,
    //       };
    //       dispatch(actions.createDealUser(dealUser));
    //       dispatch(actions.updateInvite({
    //         id: invite.id,
    //         deal: invite.deal,
    //         invitee: profile.id,
    //       }));
    //       router.push(`/dealroom/${invite.deal}/edit`);
    //     }
    //     else {
    //       router.push(`/`);
    //     }
    //   }
    // }
  }

  handleTerms = (e) => {
    this.setState({ terms: e.target.checked });
  };

  handleChange = (e) => {
    this.setState({ [e.target.getAttribute('id')]: e.target.value });
  };

  handleCountry = (e) => {
    const country = R.find(R.propEq('country', e.target.value))(countries);
    if (country) {
      this.setState(
        { country: country.country, countryCode: country.countryCodes[0] },
        this.checkAlreadyVerified
      );
    } else {
      this.setState({ country: '', countryCode: '', phoneVerified: false });
    }
  };

  checkAlreadyVerified() {
    this.setState({
      phoneVerified:
        this.state.tel === this.state.verifiedNumber &&
        this.state.countryCode === this.state.verifiedCountryCode,
    });
  }

  handleVerify = (success, number, countryCode) => {
    if (success) {
      this.setState({
        phoneVerified: true,
        verifiedNumber: number,
        verifiedCountryCode: countryCode,
      });
    } else {
      this.setState({
        phoneVerified: false,
        verifiedNumber: number,
        verifiedCountryCode: countryCode,
      });
    }
  };

  signup(e) {
    e.preventDefault();

    const { dispatch } = this.props;
    dispatch(actions.hideAlert());

    if (this.state.password !== this.state.confirmPassword) {
      dispatch(actions.alert('error', 'Passwords do not match.'));
      // } else if (!this.state.phoneVerified) {
      //   dispatch(actions.alert('error', 'Please verify your phone number.'));
    } else if (!this.state.terms) {
      dispatch(
        actions.alert(
          'error',
          'Please agree to the terms and conditions to continue.'
        )
      );
    } else {
      const { referrerId } = this.state;
      // if (!recaptchaToken) return;

      let data = {
        avatar: '',
        full_name: this.state.name,
        email: this.state.email.toLowerCase(),
        password1: this.state.password,
        password2: this.state.password,
        // address: this.state.address,
        // city: this.state.city,
        // state: this.state.state,
        // postal: this.state.postal,
        // country: this.state.country,
        // tel: this.state.tel,
        // phone_verified: this.state.phoneVerified,
        attorney: this.state.attorney,
        referrer: referrerId,
        // recaptchaToken: recaptchaToken,
      };

      dispatch(actions.signup(data));
    }
  }

  // verifyCallback = recaptchaToken => {
  //   this.setState({ recaptchaToken });
  // }

  handleNext(e) {
    e.preventDefault();
    this.submitBtn.click();
  }

  handleAttorney = (e) => {
    this.setState({ attorney: e.target.checked });
  };

  selectCountry(country) {
    this.setState({ country });
  }

  selectRegion(region) {
    this.setState({ region });
  }

  renderWork() {
    const { workTypes } = this.props;
    const { work } = this.state;

    if (work && work.type) {
      let src = null;
      let title = '';
      const workType = R.find(R.propEq('id', parseInt(work.type, 10)))(
        workTypes
      );

      if (workType) {
        switch (workType.name) {
          case 'Music':
            src = music;
            title = workType.name;
            break;
          case 'Video':
            src = video;
            title = workType.name;
            break;
          case 'Image':
            src = photo;
            title = workType.name;
            break;
          case 'Document':
            src = text;
            title = 'Literature';
            break;
          default:
            break;
        }

        return (
          <div className="works">
            <div className="work">
              <img src={src} alt={title} />
              <h1>
                {_.isEmpty(work.agreement_info)
                  ? work.name
                  : work.agreement_info.name}
              </h1>
              <h2 className="text-gray">{title}</h2>
            </div>
          </div>
        );
      }
    }
    return null;
  }

  render() {
    const { status, invite } = this.props;
    const next = invite ? `/dealroom/${invite.deal}/edit` : '/';

    return (
      <div className="welcome">
        <Heading text="Welcome to Cosynd" />
        <Row>
          <Col md={8} mdOffset={2}>
            {invite ? (
              <p>
                Hi {invite.name}, {invite.inviter_name} has invited you to
                participate in the following agreement:
              </p>
            ) : null}
            {this.renderWork()}
            <p className="text-center">
              <Link to={`/login?next=${next}`}>
                Already have an account? Sign in.
              </Link>
            </p>
            <br />
            {invite ? (
              <p>
                {invite.inviter_name} has provided the following information
                about you. If anything is incorrect, please update your
                information and complete the remaining fields.
              </p>
            ) : null}
            <hr className="transparent" />

            <Form onSubmit={(e) => this.signup(e)}>
              <Row>
                <Col md={12} lg={6}>
                  <FormGroup>
                    <FormControl
                      type="text"
                      placeholder="Your name *"
                      autoFocus
                      required
                      id="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={12} lg={6}>
                  <FormGroup>
                    <FormControl
                      type="email"
                      placeholder="Your email *"
                      required
                      id="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      readOnly={!this.state.invalidToken}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} lg={6}>
                  <FormGroup>
                    <FormControl
                      type="password"
                      placeholder="Password *"
                      required
                      id="password"
                      value={this.state.password}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={12} lg={6}>
                  <FormGroup>
                    <FormControl
                      type="password"
                      placeholder="Confirm password *"
                      required
                      id="confirmPassword"
                      value={this.state.confirmPassword}
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/* <FormGroup>
                <FormControl type="text" placeholder="Your address *" required
                  id="address" value={this.state.address} onChange={this.handleChange} />
              </FormGroup>
              <Row>
                <Col md={12} lg={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="Your city *" required
                      id="city" value={this.state.city} onChange={this.handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12} lg={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="Your state *" required
                      id="state" value={this.state.state} onChange={this.handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12} lg={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="Your zip/postal code *" required
                      id="postal" value={this.state.postal} onChange={this.handleChange} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} lg={6}>
                  <FormGroup>
                    <FormControl componentClass="select" required
                      id="country" value={this.state.country} onChange={this.handleCountry}>
                      <option>Select Country</option>
                      {countries.map((country, i) =>
                        <option key={i} value={country.country}>
                          {country.country} ({country.countryCodes[0]})
                        </option>
                      )}
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={12} lg={6}>
                  <FormGroup className="phone-verify">
                    <FormControl type="text" placeholder="Tel *" required
                      id="tel" value={this.state.tel} onChange={this.handleChange} />
                    {this.state.phoneVerified
                      ? <span className="text-green verified">Verified</span>
                      : <span className="text-gray verified">Not verified yet</span>
                    }
                    {this.state.tel && this.state.countryCode &&
                      <PhoneVerify
                        verified={this.state.phoneVerified}
                        phoneNumber={this.state.tel}
                        countryCode={this.state.countryCode}
                        done={this.handleVerify}
                      />
                    }
                  </FormGroup>
                </Col>
              </Row> */}
              <FormGroup>
                <Checkbox
                  checked={this.state.attorney}
                  onChange={this.handleAttorney}
                >
                  I am an attorney
                </Checkbox>
                <div className="helper-text">
                  By checking this box, I certify that I am a licensed attorney
                  of good standing that is licensed to practice law and that I
                  understand Cosynd’s Terms of Use. I understand that only
                  attorneys in good standing may alter the text of
                  user-generated agreements on Cosynd’s platform.
                </div>
              </FormGroup>
              <FormGroup>
                <Checkbox
                  checked={this.state.terms}
                  onChange={this.handleTerms}
                >
                  <span className="text-gray">I agree to Cosynd's </span>
                  <a
                    href="http://www.cosynd.com/policies.html#TOU"
                    target="_blank"
                  >
                    Terms & Conditions
                  </a>
                </Checkbox>
              </FormGroup>
              <hr className="transparent" />
              <FormGroup className="actions">
                <div>
                  <button
                    className="hidden"
                    ref={(r) => (this.submitBtn = r)}
                    disabled={status === actionTypes.AUTH_SIGNUP_REQUEST}
                  >
                    {status === actionTypes.AUTH_SIGNUP_REQUEST && (
                      <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                    )}
                    sign up
                  </button>
                </div>
                <div>
                  <NavButtons
                    direction="next"
                    next={(e) => this.handleNext(e)}
                  />
                </div>
              </FormGroup>
            </Form>
          </Col>
        </Row>

        {/* <ReCaptcha
          sitekey={GOOGLE_RECPATCHA_KEY}
          action="signup"
          verifyCallback={this.verifyCallback}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.auth.status,
  error: state.auth.error,
  deal: state.deals.selectedDeal,
  invite: state.invites.selectedInvite,
  inviteStatus: state.invites.status,
  isAuthenticated: state.auth.isAuthenticated,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
  profile: state.profile,
});

export default connect(mapStateToProps)(Welcome);



// WEBPACK FOOTER //
// src/pages/Welcome.jsx